// @ts-nocheck
import { CASE_CREATE_ERROR, CASE_CREATE_LOADING, CASE_CREATE_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const case_create = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: CASE_CREATE_LOADING,
                data: true
            })
            Authservices.case_create(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: CASE_CREATE_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: CASE_CREATE_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}